import React from 'react'

export default function DoubleLeftArrowIcon() {
  return (
   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 7L12 12L17 17" stroke="currentColor"/>
<path d="M12 7L7 12L12 17" stroke="currentColor"/>
</svg>

  )
}
